import { useUpNavigationStore } from "~/store/upNavigationStore.ts";
import { upNavRoutePaths } from "~/constants/upNavRouteConfig.ts";

export const useLayout = () => {
  const upNavigationStore = useUpNavigationStore();
  const route = useRoute();

  const layouts = {
    upLayout: "up-layout",
    default: "default",
  };

  const layout = computed(() => {
    if (route.path === upNavRoutePaths.monitorUpsell.path) {
      return layouts.upLayout;
    }

    return upNavigationStore.upNavFlag ? layouts.upLayout : layouts.default;
  });

  return { layout };
};
